import { NoAttribution } from "@hex/common";
import React from "react";
import { Route, Switch, useLocation } from "react-router";
import styled from "styled-components";

import { WorkspacePickerPage } from "../components/auth/WorkspacePickerPage";
import { OnboardingContainer } from "../components/login/OnboardingElements";

import { Routes, useQueryParams } from "./routes";

export const PickerContainer = styled(OnboardingContainer)`
  display: flex;
  height: 100%;
  width: 100%;

  flex-direction: column;
  align-items: center;

  overflow-y: auto;
`;

export const WorkspacePickerRoute: React.ComponentType = React.memo(
  function WorkspacePickerRoute() {
    const location = useLocation();
    const queryParams = useQueryParams();

    // TODO(VELO-4838): Replace this
    const email = queryParams.get("email") ?? undefined;

    return (
      <PickerContainer logoProps={{ linkEnabled: false }}>
        <Switch location={location}>
          <Route
            exact={true}
            path={Routes.WORKSPACE_PICKER.getUrl({
              attribution: NoAttribution,
              subView: "signUp",
            })}
          >
            <WorkspacePickerPage email={email} isSignup={true} />
          </Route>
          <Route
            exact={true}
            path={Routes.WORKSPACE_PICKER.getUrl({
              attribution: NoAttribution,
              subView: "login",
            })}
          >
            <WorkspacePickerPage email={email} isSignup={false} />
          </Route>
        </Switch>
      </PickerContainer>
    );
  },
);

export default WorkspacePickerRoute;
